import { Typography, Modal, Card, Button, Grid, Fab  }from '@mui/material';
import {SpeedOutlined, HomeOutlined, Mic, KeyboardBackspaceTwoTone } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const PitchTestsBeginModal = (props) => {
  const {showBeginModal, numQuestions, handleOpenTuneViolinModal, setShowBeginModal, totalNumLevels} = props;
  let navigate = useNavigate();

  return (
		<Modal
			open={showBeginModal}
		>
			<Card 
				className='modalCard' 
				style={{
					borderRadius: '15px', 
					minWidth: '250px', 
					// backgroundImage: isSpeedy ? 'url("/assets/images/celebrate.gif")' : '', 
					backgroundSize: '100%',
					// backgroundColor: ' #e9f3fb' // AliceBlue + more grey
				}}>
        <Grid justifyContent="flex-end" direction="row" container>
          <Fab color="extended" id="pitchTestsBeginModalIconButton" aria-label="refresh" size='small' onClick={() => navigate(-1)}>
						<KeyboardBackspaceTwoTone />
					</Fab>
					<Fab color="extended" id="pitchTestsBeginModalIconButton" aria-label="refresh" size='small' onClick={() => navigate('/')}>
						<HomeOutlined />
					</Fab>
				</Grid>
				<Typography variant="h6" component="h2">
					Can you play all these notes and play them in tune?
				</Typography>
        <Typography sx={{ mt: 2 }}>
					{`With our SightPlay Challenge, you'll face ${totalNumLevels} levels of difficulty — from easiest to hardest`}
				</Typography>
        <Typography sx={{ mt: 2 }}>
					{`In each level you will be given ${numQuestions} notes and you will have to play each note on the violin 🎻.`}
				</Typography>
        <Typography sx={{ mt: 2 }}>
					Make sure your browser mic <Mic style={{color: 'grey', verticalAlign: 'middle'}}/>  is on so we can detect the sound and intonation of your playing.
				</Typography>
        <Typography sx={{ mt: 2 }}>
					Would you like to first tune your violin?
				</Typography>
        <Grid justifyContent="center" direction="row" container style={{marginTop: '10px'}}>
					<Button onClick={handleOpenTuneViolinModal} id='modalButton' variant="outlined" color="success" style={{textTransform: 'none'}}>
            Open EasyTune 
            <SpeedOutlined style={{color: 'green', marginLeft: '1px'}} fontSize='medium'/>
          </Button>
				</Grid>
        <Typography sx={{ mt: 2 }}>
					ARE YOU READY?
				</Typography>
        <Grid justifyContent="center" direction="row" container style={{marginTop: '10px'}}>
					<Button onClick={() => setShowBeginModal(false)} id='modalButton' variant="contained" color="secondary">Let's Go!</Button>
				</Grid>
			</Card>
		</Modal>
	)
}

export default PitchTestsBeginModal;